import { render } from "./ProfileHobbies.vue?vue&type=template&id=479b6a56"
import script from "./ProfileHobbies.vue?vue&type=script&lang=js"
export * from "./ProfileHobbies.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__